import { inject } from "mobx-react";

import { RemoteList } from "../../components/remote/RemoteList.component";
import { BlockFragment } from "@ihr-radioedit/inferno-webapi";
import { getTrackHistoryWithCurrentlyPlaying, StationTrackOptions } from "../../services/LiveMeta";
import { CurrentTracks } from "./CurrentTracks.component";
import { TAKE } from "./MusicPage.component";
import type { Store } from "@inferno/renderer-shared-core";

interface CurrentTracksLoaderProps {
  store?: Store;
  block: BlockFragment;
}

export const CurrentTracksLoader = inject("store")(({ store, block }: CurrentTracksLoaderProps) => {
  if (!store) {
    return null;
  }

  const { site, cache } = store;

  const recentlyPlayedOptions: StationTrackOptions = {
    slug: site.index.slug,
    paging: {
      take: TAKE,
    },
  };

  return (
    <RemoteList cursor={getTrackHistoryWithCurrentlyPlaying(recentlyPlayedOptions, cache)} showLoading={true}>
      {remote => <CurrentTracks {...remote} block={block} />}
    </RemoteList>
  );
});
